<template>
  <div class="new-supplier">
    <div class="purchase-box">
      <el-button class="purchase-back" icon="icon-ccui-return" size="mini" type="primary" @click="purchaseBack">返回</el-button>
      <div class="cut-line"/>
      <!-- 面包屑 -->
      <el-breadcrumb class="purchase-crumbs" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/#/zh-CN/component/breadcrumb' }">审批中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/#/zh-CN/component/breadcrumb' }">供应商</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/#/zh-CN/component/breadcrumb' }">供应商注册</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="supplier-box">
      <el-card-title :title="title"/>
      <div class="form-content">
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="合同名称：">
            <el-input v-model="form.input" class="input-long" placeholder="请输入合同名称"/>
          </el-form-item>
          <el-form-item label="合同类型：">
            <el-select v-model="value" class="select-long" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="经管部门：">
            <el-select v-model="value" class="select-long" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="需用部门：">
            <el-select v-model="value" class="select-long" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="是否甲控：">
            <el-radio v-model="radio" label="1">是</el-radio>
            <el-radio v-model="radio" label="2">否</el-radio>
          </el-form-item>
          <el-form-item label="合同丙方：">
            <el-input v-model="form.input" class="input-long" placeholder="请选择"/>
          </el-form-item>
          <el-form-item label="定价方式：">
            <el-select v-model="value" class="select-long" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="有效期限：">
            <div class="block">
              <el-date-picker
                v-model="value14"
                placeholder="开始时间"
                type="dates"/>
              <div class="demonstration"/>
              <el-date-picker
                v-model="value14"
                placeholder="结束时间"
                type="dates"/>
            </div>
          </el-form-item>
          <el-form-item label="合同条款：">
            <el-input
              v-model="textarea3"
              :autosize="{ minRows: 7, maxRows: 7}"
              type="textarea"
              maxlength="100"
              placeholder="请输入内容"/>
            <div class="textLength">{{ textLength }}/100</div>
          </el-form-item>
        </el-form>
      </div>
      <el-card-title :title="title1"/>
      <div class="supplierCostitem">
        <div class="llll">
          <el-button icon="icon-ccui-add" type="bottom" @click="supplierDdit">添加费项</el-button>
        </div>
        <el-table
          :data="tableData">
          <el-table-column
            prop="id"
            label="序号"
            width="50"/>
          <el-table-column
            prop=""
            label="费项名称"
            width="130">
            <template slot-scope="scope">
              <el-input v-model="input" class="input-short" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            label="税费类型"
            width="130">
            <template slot-scope="scope">
              <el-select v-model="value" placeholder="请选择" class="select-short">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            label="费项类型"
            width="130">
            <template slot-scope="scope">
              <el-select v-model="value" placeholder="请选择" class="select-short">
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="税费类型"
            width="">
            <el-table-column
              prop="zip"
              label="含税金额"
              width="">
              <template slot-scope="scope">
                <el-input v-model="input" class="input-short" placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column
              prop="zip"
              label="税后金额"
              width=""/>
            <el-table-column
              prop="zip"
              label="抵税后金额"
              width=""/>
            <el-table-column
              prop="zip"
              label="税额"
              width=""/>
          </el-table-column>
          <el-table-column
            prop="date"
            label="计算方式"
            width="170">
            <template slot-scope="scope">
              <el-select v-model="value" placeholder="正" class="select-short">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.province"
                  :value="item.province"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            label="操作"
            width="84">
            <template slot-scope="scope">
              <el-button size="mini" type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-card-title :title="title2"/>
      <div class="supplierCostitem">
        <el-table
          :data="tableData">
          <el-table-column
            type="selection"
            width="50"/>
          <el-table-column
            prop="date"
            label="序号"
            width="50"/>
          <el-table-column
            prop=""
            label="物料编码"
            width=""/>
          <el-table-column
            prop="date"
            label="物料名称"
            width=""/>
          <el-table-column
            prop="date"
            label="采购数量"
            width=""/>
          <el-table-column
            prop="date"
            label="计量单位"
            width=""/>
          <el-table-column label="含税单价组成" width="90">
            <el-table-column
              prop="name"
              label="综合单价"
              width=""/>
          </el-table-column>
          <el-table-column
            prop="date"
            label="中标含税综合单价"
            width="289"/>
          <el-table-column
            prop="date"
            label="操作"
            width=""/>
        </el-table>
      </div>
      <el-card-title :title="title3"/>
      <div class="supplierCostitem-title3">
        <div class="llll">
          <el-button icon="icon-ccui-add" type="bottom" @click="supplierDdit">添加费项</el-button>
        </div>
        <el-table
          :data="tableData"
          border>
          <el-table-column
            prop="id"
            label="序号"
            width="44"/>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="filename"
            label="文件名称"
            width="490"/>
          <el-table-column
            prop="date"
            label="文件类型"
            width=""/>
          <el-table-column
            prop="date"
            label="合同编号"
            width=""/>
          <el-table-column
            prop="date"
            label="合同版本"
            width=""/>
          <el-table-column
            prop="date"
            label="操作"
            width="">
            <template slot-scope="scope">
              <el-button size="mini" type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <p class="supplier-explain">支持xls，xlsx，doc，docx，pdf，jpg，png，zip，rar文件格式，大小不超过20MB</p>
        <p class="supplier-explainp">附件说明：</p>
        <el-input
          v-model="textarea"
          :autosize="{ minRows: 7, maxRows: 7}"
          type="textarea"
          maxlength="100"
          placeholder="请输入内容"/>
        <div class="textLength">{{ ttextareaLength }}/100</div>
      </div>
    </div>
    <div class="detail-bottom">
      <ul class="detail-bottom-center">
        <li>
          <el-button icon="icon-ccui-return" type="bottom" @click="purchaseBack">返回</el-button>
        </li>
        <div class="bottom-center-solid"/>
        <li>
          <el-button icon="icon-ccui-save-temporary" type="bottom" @click="supplierDdit">暂存</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-save" type="bottom">保存</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-save-submit" type="bottom">保存并提交</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-cancel" type="bottom">取消</el-button>
        </li>
        <div class="bottom-center-solid-two"/>
        <li>
          <el-button icon="icon-ccui-export" type="bottom">导出</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-copy" type="bottom">复制</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-print" type="bottom">打印</el-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import { getList } from '@/api/new-supplier'

export default {
  name: 'NewContract',
  data() {
    return {
      pageNo: 4,
      pageSize: 10,
      title: '基本信息',
      content: '添加费项',
      title1: '费项组成',
      title2: '采购清单',
      title3: '合同附件',
      textarea: '',
      ttextareaLength: 0,
      radio: '1',
      value14: '',
      input: '',
      form: {
        input: ''
      },
      options: [
        {
          value: '选项1',
          label: '增值税'
        },
        {
          value: '选项2',
          label: '消费税'
        },
        {
          value: '选项3',
          label: '营业税'
        }
      ],
      options1: [
        {
          value: '选项1',
          label: '电话费'
        },
        {
          value: '选项2',
          label: '租赁费'
        },
        {
          value: '选项3',
          label: '审计费'
        }
      ],
      value: '',
      tableData: [],
      textarea3: '',
      textLength: 0
    }
  },
  watch: {
    textarea3() {
      this.textLength = this.textarea3.length
    },
    textarea() {
      this.ttextareaLength = this.textarea.length
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      const obj = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShowLoading: true,
        data: { ...this.formLabelAlign }
      }
      getList(obj).then(res => {
        this.tableData = res.data.tableData
      })
    },
    purchaseBack() {
      this.$router.push({ path: '/approval/supplier/supplier-detail/id' })
    },
    supplierDdit() {
      this.$router.push({ path: '/approval/supplier/supplier-detail/id' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .new-supplier{
    overflow: hidden;
    .supplier-box{
      overflow: hidden;
      .form-content{
        .el-form{
          /deep/ label{
            font-weight:400;
          }
          .input-long{
            width: 430px;
          }
          .select-long{
            width: 430px;
          }
          .textarea-long{
            width:427px;
            margin-top: 9px;
          }
          .el-form-item{
            position: relative;
            margin-bottom: 20px;
            /deep/ .el-form-item__content{
              width: 430px;
            }
            /deep/ .textLength{
              font-size:13px;
              font-family:PingFangSC-Regular;
              font-weight:400;
              color:rgba(74,74,74,1);
              position: absolute;
              right: 20px;
              bottom: 10px;
              line-height: 1;
            }
          }
        }
        .el-form>div:last-child{
          /deep/ .el-form-item__label{
            line-height: 1;
          }
        }
      }
      .llll{
        .el-button{
          background: #fff;
          border: none;
          padding: 0;
          font-size: 13px;
          color: #0089EF;
          font-family:PingFangSC-Medium;
          font-weight:500;
          /deep/ .icon-ccui-add{
            margin-right: 4px;
            float: left;
            font-size: 12px;
            margin-top: 1px;
          }
        }
      }
    }
    /deep/ .el-form>div:nth-of-type(4){
      margin-bottom: 24px !important;
    }
    /deep/ .el-form>div:nth-of-type(5){
      margin-bottom: 24px !important;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner{
      width: 195px;
      float: left;
    }
    .demonstration{
      width:14px;
      height:2px;
      background:rgba(204,204,204,1);
      border-radius:1px;
      display: inline-block;
      float: left;
      margin: 14px 13px 0 13px;
    }
    .el-card-title{
      margin-top: 10px;
    }
    .supplierCostitem{
      padding: 20px 20px 0 20px;
      position: relative;
      .el-table{
        /deep/ th{
          padding: 1px 0 0 0;
          font-size:13px;
          height: 25px;
          line-height: 0;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(74,74,74,1);
          background: #fff;
          /deep/ .el-checkbox__inner{
            margin-left: 5px;
          }
        }
        /deep/ .el-table_5_column_26{
          text-align: center;
        }
        /deep/ .el-table_6_column_39{
          text-align: center;
        }
        /deep/ .el-table_6_column_39_column_40{
          text-align: center;
        }
        /deep/ .el-table__row{
          /deep/ .el-checkbox{
            margin-left: 5px;
          }
        }
        /deep/ .el-table_2_column_18{
          text-align: center;
        }
        /deep/ .el-table_2_column_18_column_19{
          text-align: center;
        }
        /deep/ td{
          padding: 0;
          font-size:13px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(74,74,74,1);
          /deep/ .cell{
            line-height: 35px;
          }
          /deep/ .input-short{
            width: 100%;
            .el-input__inner{
              background:rgba(241,241,241,1);
              border: none;
              height: 22px;
              border-radius: 2px;
            }
          }
          /deep/ .select-short{
            width: 100%;
            /deep/ .el-input{
              .el-input__inner{
                border: none;
                height: 22px;
                border-radius: 2px;
              }
            }
            .el-input__inner{
              background:rgba(241,241,241,1);
            }
          }
        }
      }
    }
    .supplierCostitem-title3{
      padding: 0 20px;
      margin-top: 20px;
      position: relative;
      .el-table{
        /deep/ .el-table__body-wrapper{
          height: 36px;
        }
        /deep/ .el-table_1_column_1{
          text-align: center;
        }
        /deep/ th{
          padding: 6px 0;
          font-size:13px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(74,74,74,1);
          background: #fff;
          border-right: none;
          .cell{
            padding-left: 0;
            margin-left: 10px;
          }
        }
        /deep/ td{
          padding: 0 !important;
          font-size:13px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(74,74,74,1);
          border-right: none;
          /deep/ .cell{
            line-height: 35px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
        }
      }
      /deep/ .el-textarea{
        width: 94.8%;
        margin-top: 19px;
        margin-bottom: 20px;
      }
      /deep/ .textLength{
        font-size:13px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(74,74,74,1);
        position: absolute;
        right: 30px;
        bottom: 30px;
      }
      .supplier-explain{
        font-size:13px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(155,155,155,1);
        line-height:18px;
        margin-top: 10px;
      }
      .supplier-explainp{
        width:65px;
        height:18px;
        font-size:13px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(74,74,74,1);
        float: left;
        margin-top: 20px;
      }
      .textarea-long{
        width:calc(100% - 65px);
        height: 165px;
        margin-top: 14px;
      }
    }
    .el-table__body{
      width: 100%;
    }
    .form-content{
      margin-top: 26px;
      padding: 0 41px;
    }
    .purchase-box {
      margin: 0 0 15px 0 !important;
      /deep/ .purchase-back{
        width: 70px;
        font-size: 14px;
        padding: 6px 9px;
        float: left;
        /deep/ .icon-ccui-return{
          font-size: 16px;
          margin-right: 8px;
          float: left;
        }
        span{
          display: block;
          margin-top: -6px;
        }
      }
      .el-breadcrumb.purchase-crumbs{
        line-height: 30px;
      }
      .cut-line{
        width:1px;
        height:21px;
        background:rgba(216,216,216,1);
        float: left;
        margin: 5px 20px 0 20px;
      }
    }
    .supplier-box{
      .llll{
        width: 65px;
        height: 18px;
        position: absolute;
        right: 28px;
        top: -26px;
        z-index: 1;
      }
      background: #fff;
      .el-card-title{
        width: 97%;
        height: 32px;
        /deep/ .details-title-message{
          font-size:13px;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color:rgba(0,137,239,1);
        }
      }
      .icon-ccui-add{
        position: absolute;
        right: 79px;
        top: 14px;
      }
    }
    .supplier-box>div:nth-of-type(4){
      /deep/ .is-group>tr:first-child>th:nth-of-type(5){
        text-align: center;
      }
    }
    .supplier-box>div:nth-of-type(6){
      /deep/ .is-group>tr:first-child>th:nth-of-type(7){
         text-align: center;
      }
      /deep/ .is-group>tr:last-child>th:first-child{
        text-align: center;
      }
      /deep/ .el-table__body-wrapper{
        .el-table__row>td:nth-of-type(7){
          text-align: center;
        }
      }
    }
    .detail-bottom {
      width: 100%;
      height: 40px;
      background: #9e9e9e !important;
      float: left;
      margin: 20px 0 20px 0;
      background: rgba(76, 76, 76, 0.5);
      .detail-bottom-center {
        width: 57%;
        height: 40px;
        margin: 0 auto;
        position: relative;
      }
      .detail-bottom-center > li {
        float: left;
        list-style: none;
        line-height: 40px;
        /deep/ i{
          float: left;
          font-size: 16px;
        }
        /deep/ span{
          font-size:13px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(255,255,255,1);
        }
      }
      .bottom-center-solid {
        width:1px;
        height:20px;
        background:rgba(196,196,196,1);
        border-radius:1px;
        float: left;
        margin: 10px 20px 0 20px;
      }
      .bottom-center-solid-two {
        width:1px;
        height:20px;
        background:rgba(196,196,196,1);
        border-radius:1px;
        float: left;
        margin: 10px 20px 0 20px;
      }
    }
  }
  @media screen and (max-width: 1425px) {
    .detail-bottom-center{
      width: 65% !important;
    }
    .supplierCostitem-title3{
      /deep/ .el-textarea{
        width: 94% !important;
      }
    }
  }
</style>
